import React from "react";
import { IntlShape, RawIntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import { observer } from "mobx-react-lite";
import { PrimeReactProvider } from 'primereact/api';
import { ThemeProvider } from "styled-components";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router";
import { Home } from "components/Home"
import { Welcome } from "components/Welcome"
import { Releases } from "components/Releases"
import { NewRelease } from "components/NewRelease";
import { NotFound } from "components/NotFound";
import { SignUp, SignIn, RecoveryPassword, SignUpConfirm, NewPassword, RecoveryPasswordCompleted } from "components/Auth";
import { ProtectedRoute } from "ui-kit/ProtectedRoute";
import { Routes as AppRoutes } from "constants/routes"
import IntlStore from "stories/IntlStore"
import ThemeStore from "stories/ThemeStore"
import PublicRoute from "ui-kit/PublicRoute";
import { AuthLayout, MainLayout } from "components/Layouts";
import { ReleaseDetails } from 'components/ReleaseDetails'
import { Artists } from "components/Artists";
import { ArtistsDetails } from "components/ArtistsDetails";
import { Labels } from "components/Labels";
import { LabelDetail } from "components/Labels/LabelDetail";
import { Tracks } from "components/Tracks";
import { Authors } from "components/Authors";
import { Library } from "components/Library";
import { Analytics } from "components/Analytics";
import { useLocalization } from "./hooks/useLocalization";
import { SmartLinks } from "components/SmartLinks";
import { SmartLinkCreation } from "components/SmartLinks/SmartLinkCreation";
import { SmartLinkList } from "components/SmartLinks/SmartLinksList";
import { AICompose } from "components/AICompose";
import { Prices } from "components/Prices";
import { Song } from "components/AICompose/Share/Song";
import { PlaylistView } from "components/AICompose/Share/Playlist";
import { ToastContainer as CustomToastContainer } from "components/ui-kit/Toast";
import { SmartLinkAnalytics } from "components/SmartLinks/Analytics/Analytics";
import {Finance} from "components/Finance";
const devClientId = "566255868643-agguv25u34n0kmct2r0sd8t875robtea.apps.googleusercontent.com";
const prodClientId = "103758974454-9vmlfvl1nmq0196ndffic41bq4u4u5ar.apps.googleusercontent.com";

const App: React.FC = observer(() => {
  const { getLocalization } = useLocalization();

  React.useEffect(() => {
    IntlStore.locale && getLocalization(IntlStore.locale);
  }, [IntlStore.locale])

  return (
    <RawIntlProvider value={IntlStore.intl as IntlShape}>
      <ThemeProvider theme={ThemeStore.activeTheme}>
        <GoogleOAuthProvider clientId={prodClientId}>
          <PrimeReactProvider>
            <ToastContainer />
            <CustomToastContainer />
            <BrowserRouter>
              <Routes>
                <Route element={<PublicRoute><AuthLayout /></PublicRoute>}>
                  <Route path={AppRoutes.SignIn} element={<SignIn />} />
                  <Route path={AppRoutes.SignUp} element={<SignUp />} />
                  <Route path={AppRoutes.RecoveryPassword} element={<RecoveryPassword />} />
                  <Route path={AppRoutes.SignUpConfirm} element={<SignUpConfirm />} />
                  <Route path={AppRoutes.NewPassword} element={<NewPassword />} />
                  <Route path={AppRoutes.RecoveryPasswordCompleted} element={<RecoveryPasswordCompleted />} />
                </Route>
                <Route
                  path={AppRoutes.General}
                  element={(
                    <ProtectedRoute>
                      <MainLayout />
                    </ProtectedRoute>
                  )}
                >
                  <Route index element={<Welcome />} />
                  <Route path={AppRoutes.SelectSmartLink} element={<SmartLinks />} />
                  <Route path={AppRoutes.SmartLinks} element={<SmartLinkList />} />
                  <Route path={AppRoutes.SmartLinkAnalytics} element={<SmartLinkAnalytics />} />
                  <Route path={AppRoutes.SmartLinks} element={<SmartLinkList />} />
                  <Route path={AppRoutes.Welcome} element={<Welcome />} />
                  <Route path={AppRoutes.Releases} element={<Releases />} />
                  <Route path={AppRoutes.NewRelease} element={<NewRelease />} />
                  <Route path={AppRoutes.ReleaseDetails} element={<ReleaseDetails />} />
                  <Route path={AppRoutes.Artists} element={<Artists />} />
                  <Route path={AppRoutes.ArtistsDetails} element={<ArtistsDetails />} />
                  <Route path={AppRoutes.SmartLinkCreation} element={<SmartLinkCreation />} />
                  <Route path={AppRoutes.SmartLinkEdit} element={<SmartLinkCreation />} />
                  <Route path={AppRoutes.Labels} element={<Labels />} />
                  <Route path={AppRoutes.LabelsDetails} element={<LabelDetail />} />
                  <Route path={AppRoutes.Tracks} element={<Tracks />} />
                  <Route path={AppRoutes.ArtistsDetails} element={<ArtistsDetails />} />
                  <Route path={AppRoutes.Authors} element={<Authors />} />
                  <Route path={AppRoutes.Library} element={<Library />} />
                  <Route path={AppRoutes.Analytics} element={<Analytics />} />
                  <Route path={AppRoutes.AICompose} element={<AICompose />} />
                  <Route path={AppRoutes.Prices} element={<Prices />} />
                  <Route path={AppRoutes.Finance} element={<Finance />} />
                  <Route path={AppRoutes.Song} element={<Song />} />
                  <Route path={AppRoutes.Playlist} element={<PlaylistView />} />

                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </PrimeReactProvider>
        </GoogleOAuthProvider>
      </ThemeProvider>
    </RawIntlProvider>
  );
});

export default App;
